import { identityActions, productActions } from '../../services';
import { extractDataFromJwt } from '../../util';

export const identityDispatcher = dispatch => ( { 
  identify: cId => {
    return dispatch( { type: identityActions.GET, cId } ).then( response => {
      const payload = extractDataFromJwt( response.data );

      if ( payload.exp ) {
        let now = Math.ceil( ( ( payload.exp - payload.iat ) / 10000 ) * .9 );
        setTimeout( () => {
          identityDispatcher( dispatch ).identify( cId );
        }, now );
      }
      
      return response;
    } );
  },
  failed: message => dispatch( { type: identityActions.LOAD, data: { failed: true, message: message } } ),
  updateUser: data => dispatch({type: identityActions.UPDATE, data}).then(dispatch( { code: {}, type: productActions.RESET, products:  {}} ))
} );
